import React, { useState } from 'react';

import { filter } from '../../commonFunctions/filterFunction'

import { FaCaretUp, FaCaretDown } from 'react-icons/fa'

import "./style.css";

const CustomFilterIcons = ({ Sort, active }) => {

    return (
        <div className="custom-sort">
            <FaCaretUp
                size={15}
                style={{ cursor: 'pointer', color: (active == "asc") ? "#c2714f" : "#3d3d3d" }}
                onClick={() => {
                    Sort("asc");
                }} />
            <FaCaretDown
                size={15}
                style={{ cursor: 'pointer', color: (active == "desc") ? "#c2714f" : "#3d3d3d" }}
                onClick={() => {
                    Sort("desc");
                }} />
        </div>
    );
};

export default CustomFilterIcons;